const state = {
  javascriptStore:
    [
      {
        id: 1,
        title_en: "JavaScript Starter",
        title_ua: "JavaScript Стартовий",
        title_es: "JavaScript Inicio",
        regnumber: "TP47415802",
        grade: "929 / 1000",
        examdate: "14.05.2021",
        image: "https://testprovider.com/ru/search-certificate/tp47415802",
      },
      {
        id: 2,
        title_en: "JavaScript Essential 2015",
        title_ua: "JavaScript Базовий 2015",
        title_es: "JavaScript Básico 2015",
        regnumber: "TP00355566",
        grade: "920 / 1000",
        examdate: "07.09.2022",
        image: "https://testprovider.com/ru/search-certificate/tp00355566",
      },
      {
        id: 3,
        title_en: "JavaScript Essential 2021",
        title_ua: "JavaScript Базовий 2021",
        title_es: "JavaScript Básico 2021",
        regnumber: "TP26716836",
        grade: "1000 / 1000",
        examdate: "22.07.2021",
        image: "https://testprovider.com/ru/search-certificate/tp26716836",
      },
      {
        id: 4,
        title_en: "JavaScript Advanced 2015",
        title_ua: "JavaScript Поглиблений 2015",
        title_es: "JavaScript Avanzado 2015",
        regnumber: "TP06245805",
        grade: "975 / 1000",
        examdate: "23.06.2021",
        image: "https://testprovider.com/ru/search-certificate/tp06245805",
      },
      {
        id: 5,
        title_en: "JavaScript Patterns",
        title_ua: "JavaScript Шаблони",
        title_es: "Plantillas de Javascript",
        regnumber: "TP95784000",
        grade: "1000 / 1000",
        examdate: "25.06.2021",
        image: "https://testprovider.com/ru/search-certificate/tp95784000",
      },
      {
        id: 6,
        title_en: "ECMAScript 6",
        title_ua: "ECMAScript 6",
        title_es: "ECMAScript 6",
        regnumber: "TP61852573",
        grade: "1000 / 1000",
        examdate: "28.06.2021",
        image: "https://testprovider.com/ru/search-certificate/tp61852573",
      },
      {
        id: 7,
        title_en: "JavaScript Extended capabilities",
        title_ua: "JavaScript. Розширені можливості",
        title_es: "JavaScript. Capacidades extendidas",
        regnumber: "TP59539891",
        grade: "1000 / 1000",
        examdate: "30.06.2021",
        image: "https://testprovider.com/ru/search-certificate/tp59539891",
      },
      {
        id: 8,
        title_en: "Asynchronous programming in JavaScript",
        title_ua: "Асинхронне програмування у JavaScript",
        title_es: "Programación asincrónica en JavaScript",
        regnumber: "TP35598802",
        grade: "975 / 1000",
        examdate: "19.04.2024",
        image: "https://testprovider.com/ru/search-certificate/tp35598802",
      },
    ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};